resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
    File that contains function additions to native JS classes
*/

Array.prototype.contains = function (element) {
  return this.indexOf(element) > -1;
};

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

Date.prototype.stdTimezoneOffset = function () {
  var jan = new Date(this.getFullYear(), 0, 1);
  var jul = new Date(this.getFullYear(), 6, 1);
  return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
};

Date.prototype.isDaylightSavingsTime = function () {
  return this.getTimezoneOffset() < this.stdTimezoneOffset();
};

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}


/*
  UTCTimeOffset
    Integer | String
      In minutes as an Integer; or as a timezone offset string. Eg. +05:30
*/
Date.getOtherTimezoneTime = function (date, UTCTimeOffset) {
  var otherTimezoneDate = new Date(date);

  var minutesAdjust = 0;
  if (typeof UTCTimeOffset === 'string') {
    var tz = UTCTimeOffset.split(':');
    minutesAdjust = parseInt(tz[0]) * 60;
    minutesAdjust =
      minutesAdjust < 0 ? minutesAdjust - parseInt(tz[1]) : minutesAdjust + parseInt(tz[1]);
    minutesAdjust = minutesAdjust + otherTimezoneDate.getTimezoneOffset();
  } else {
    minutesAdjust = otherTimezoneDate.getTimezoneOffset() + UTCTimeOffset;
  }
  otherTimezoneDate.setMinutes(otherTimezoneDate.getMinutes() + minutesAdjust);
  return otherTimezoneDate;
};

Date.getISO8601Date = function (year, month, day, hours, minutes, seconds, UTCTimeOffset) {
  if (typeof UTCTimeOffset === 'string') {
    if (UTCTimeOffset.charAt(0) !== '-' && UTCTimeOffset.charAt(0) !== '+') {
      UTCTimeOffset = '+' + UTCTimeOffset;
    }
    if (UTCTimeOffset.length === 5) {
      UTCTimeOffset = UTCTimeOffset.slice(0, 1) + '0' + UTCTimeOffset.slice(1);
    }
  } else {
    UTCTimeOffset = 'Z';
  }
  return (
    '' +
    year +
    '-' +
    (month < 10 ? '0' : '') +
    month +
    '-' +
    (day < 10 ? '0' : '') +
    day +
    'T' +
    (hours < 10 ? '0' : '') +
    hours +
    ':' +
    (minutes < 10 ? '0' : '') +
    minutes +
    ':' +
    (seconds < 10 ? '0' : '') +
    seconds +
    UTCTimeOffset
  );
};

Date.toFormattedString = function (date, format) {
  var d = date.getDate();
  var dd = (d < 10 ? '0' : '') + d;
  var m = date.getMonth() + 1;
  var mm = (m < 10 ? '0' : '') + m;
  var mmm = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][
    m - 1
  ];
  var yyyy = date.getFullYear();
  var H = date.getHours();
  var HH = (H < 10 ? '0' : '') + H;
  var M = date.getMinutes();
  var MM = (M < 10 ? '0' : '') + M;
  var s = date.getSeconds();
  var ss = (s < 10 ? '0' : '') + s;

  switch (format) {
    case 'mmm dd, yyyy':
      return mmm + ' ' + dd + ', ' + yyyy;
    case "yyyy-mm-dd'T'HH:MM:ss":
      return yyyy + '-' + mm + '-' + dd + 'T' + HH + ':' + MM + ':' + ss;
    default:
      return date.toDateString();
  }
};

/* Polyfill for Object.assign() (IE11) */
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign (target, varArgs) {
      // .length of function is 2
      'use strict';
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}
